import { Collapse, Typography } from 'antd';
import React from 'react';
import { IOrderHeaderCardsProps } from './OrderHeaderCards.props';

const { Text } = Typography;

// Caption on the left, the live facts on the right, so a closed panel still answers the question.
const panelLabel = (caption: string, summary?: React.ReactNode) => (
  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, minWidth: 0 }}>
    <Text type="secondary" strong style={{ fontSize: 14, flexShrink: 0 }}>
      {caption}
    </Text>
    {summary && (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: 12,
        }}
      >
        {summary}
      </span>
    )}
  </span>
);

export const OrderHeaderCardsMobile: React.FC<IOrderHeaderCardsProps> = ({
  jobCard,
  customerCard,
  invoiceCard,
  jobSummary,
  customerSummary,
  invoiceSummary,
}) => (
  <Collapse
    bordered={false}
    defaultActiveKey={[]}
    style={{ background: '#fafcff', marginBottom: 8 }}
    items={[
      {
        key: 'job',
        label: panelLabel('Job card', jobSummary),
        children: jobCard,
        style: { padding: 0 },
      },
      {
        key: 'customer',
        label: panelLabel('Customer & vehicle', customerSummary),
        children: customerCard,
        style: { padding: 0 },
      },
      {
        key: 'invoice',
        label: panelLabel('Invoice', invoiceSummary),
        children: invoiceCard,
        style: { padding: 0 },
      },
    ]}
  />
);
